import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
  createUDPUiTypeMapper,
} from '@wix/editor-elements-integrations';
import { getMigratedStyleProps } from '@wix/editor-elements-common-utils';
import type {
  ICollapsibleTextMapperProps,
  CollapsibleTextDefinition,
  ButtonAlignment,
  ICollapsibleTextStateValues,
} from '../CollapsibleText.types';
import { alignmentToStyle } from '../constants';

export const props = withCompInfo<
  ICollapsibleTextMapperProps,
  CollapsibleTextDefinition
>()(
  [
    'compData',
    'compProps',
    'compStylableClass',
    'isConnectedToDataBinding',
    'styleProperties',
    'compId',
    'fullNameCompType',
    'language',
    'mainPageId',
    'trackClicksAnalytics',
    'experiments',
  ],
  ({
    compData,
    compProps,
    styleProperties,
    isConnectedToDataBinding,
    compStylableClass: stylableClassName,
    experiments,
    ...restCompProps
  }) => {
    const migratedProps = getMigratedStyleProps({
      compProps,
      styleProperties,
      migratedFields: ['alignButton'],
    });

    const shouldResolveLinksInPlace = Boolean(
      experiments['specs.thunderbolt.resolveLinksInPlace'],
    );

    return {
      ...compData,
      ...(isConnectedToDataBinding ? { tag: 'div' } : {}),
      ...compProps,
      ...restCompProps,
      ...migratedProps,
      stylableClassName,
      // TODO: Change when correct type is added to TB
      link:
        (shouldResolveLinksInPlace
          ? compData.link
          : (compData.link as any)?.resolvedLink) || null,
    };
  },
);

export const css = withCompInfo()(
  ['compProps', 'styleProperties'],
  ({ compProps, styleProperties }) => {
    const { maxLines, expandControlSpacing } = compProps;

    const migratedProps = getMigratedStyleProps({
      compProps,
      styleProperties,
      migratedFields: ['alignButton'],
    });

    const alignSelf =
      alignmentToStyle[migratedProps.alignButton as ButtonAlignment] ||
      alignmentToStyle.left;
    return {
      height: 'auto',
      '--max-lines': maxLines,
      '--expand-control-spacing': `${expandControlSpacing}px`,
      '--expand-control-align': `${alignSelf}`,
    };
  },
);

export const stateRefs = withStateRefsValues<keyof ICollapsibleTextStateValues>(
  ['reportBi'],
);

export const uiType = createUDPUiTypeMapper('Default', 'CollapsibleText');

export default createComponentMapperModel({
  props,
  css,
  stateRefs,
  uiType,
});
